import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Storage } from '@ionic/storage-angular'

const KEY = 'slug-to-open'

@Injectable({
  providedIn: 'root',
})
export class UrlOpenService {
  constructor(private router: Router, private storage: Storage) {}

  async register(slug) {
    this.storage.set(KEY, slug)
  }

  async process() {
    const slug = await this.storage.get(KEY)
    if (!slug) return
    await this.storage.remove(KEY)
    this.router.navigateByUrl(slug, { replaceUrl: true })
  }
}
